import React, { useEffect, useState, useContext, useRef } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import PropTypes from 'prop-types';
import axios from 'axios';

import { faDownload, faCopy } from '@fortawesome/free-solid-svg-icons';
import VisibilitySharpIcon from '@mui/icons-material/VisibilitySharp';
import BugReportIcon from '@mui/icons-material/BugReport';

import { GlobalTypes } from '../../../types/global';
import { GlobalContext } from '../../../context/GobalState';
import { api, apiRecords } from '../../../api/api';
import { formatDuration, formatPhoneNumber } from 'helpers';

import Button from '../Button/Button';
import Eye from 'components/molecules/VisiblityEye/VisiblityEye';
import Tree from '../../organisms/Tree/Tree';
import TabPanel from '../TabPanel/TabPanel';

import {
  ConnectionInfo,
  StyledContent,
  ConversationLog,
  LogWrapper,
  ConnectionDetails,
  BorderContainer,
} from './ModalFlow.styles';

// Dane odnośnie poszczególnego wiersza pobieramy gdy isActvie jest true, nie rzuca wtedy błędem
const ModalFlow = ({ data, isActive, setLastOpenItemId, tabValue, index }) => {
  const [isExpert, setIsExpert] = useState(false);
  const [connectionData, setConnectionData] = useState([]);
  const [showBorderTop, setShowBorderTop] = useState(false);
  const [showBorderBottom, setShowBorderBottom] = useState(false);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(true);
  const [talkId, setTalkId] = useState('');
  const [downloadLogLink, setDownloadLogLink] = useState('');
  const [recFilePath, setRecFilePath] = useState('');
  const [blobUrl, setBlobUrl] = useState('');
  const [spaceBetween] = useState(true);

  const { authToken, permissionLevel } = useContext(GlobalContext);
  const handleError = useErrorHandler();
  const scroll = useRef();
  const audioRef = useRef();

  useEffect(() => {
    setLastOpenItemId(talkId);
  }, [setLastOpenItemId, talkId]);

  useEffect(() => {
    if (permissionLevel === GlobalTypes.PERMISSION_LEVEL) {
      setIsExpert(true);
    }
  }, [permissionLevel]);

  useEffect(() => {
    if (isActive && data && authToken) {
      axios
        .get(`${api}data/data/${data.map((el) => el.talk_id)}`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(
          ({ data }) => {
            setConnectionData(data);
            data.rec_file_path ? setRecFilePath(data.rec_file_path) : setRecFilePath('');
          },
          {
            headers: {
              'Content-Type': 'application/json'
            },
          }
        )
        .catch((error) => {
          alert('Something went wrong');
          console.log(error);
        });
    }

    if (!isActive) {
      setConnectionData([]);
    }
  }, [data, isActive, authToken, handleError]);

  useEffect(() => {
    if (!isActive) {
      updateAudioPlayer('');
    }
  }, [isActive]);

  useEffect(() => {
    if (!!recFilePath && isActive) {
      (async () => {
        const headers = new Headers();
        const username = 'u589829-sub10';
        const password = 'xYzJOEbpC51h1!';
        headers.set('Authorization', 'Basic ' + btoa(username + ':' + password));

        const result = await fetch(`${apiRecords}${recFilePath}`, {
          headers: headers,
        });
        const blob = await result.blob();

        if (blob) {
          updateAudioPlayer(URL.createObjectURL(blob));
        } else {
          console.warn('Error while downloading a blob');
          updateAudioPlayer('');
        }
      })();
    } else {
      updateAudioPlayer('');
    }
  }, [recFilePath, isActive]);

  // useEffect(() => {
  //   if (isActive && talkId) {
  //     (async () => {
  //       const result = await fetch(`${api}data/download_log/${talkId}/`, {
  //         headers: {
  //           Authorization: `token ${authToken}`,
  //         },
  //       });

  //       const blob = await result.blob();

  //       if (blob) {
  //         setDownloadLogLink(URL.createObjectURL(blob));
  //       } else {
  //         console.warn('Error while downloading a blob');
  //       }
  //     })();
  //   }
  // }, [talkId, isActive, authToken]);

  useEffect(() => {
    data[0]?.talk_id && setTalkId(data[0].talk_id);
  }, [data]);

  const updateAudioPlayer = (sourceUrl) => {
    setBlobUrl(sourceUrl);
    setIsDownloadDisabled(sourceUrl ? false : true);
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.load();
    }
  };

  const onScroll = (e) => {
    const currentScrollY = e.target.scrollTop;
    if (currentScrollY > 0) {
      setShowBorderTop(true);
    } else {
      setShowBorderTop(false);
    }

    if (e.target.offsetHeight + currentScrollY >= e.target.scrollHeight) {
      setIsScrolledToBottom(true);
    } else {
      setIsScrolledToBottom(false);
    }
  };

  const copyToClipboard = (text) => {
    const elem = document.createElement('textarea');
    elem.value = text;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand('copy');
    document.body.removeChild(elem);
  };

  const {
    duration,
    lead_number,
    phone_number,
    start_time,
    business_status,
    logical_status,
    technical_status,
    processing_status,
  } = connectionData;

  const jiraTicket = () => {
    axios
      .post(
        `${api}data/jira_issue/`,
        {
          vee_skill: 'Pudełko',
          lead_number: lead_number,
          phone_number: phone_number,
          start_time: start_time,
          panel_link: `${window.location.origin}${window.location.pathname}/!${talkId}`,
          logical_status: business_status,
        },
        {
          headers: {
            Authorization: `token ${authToken}`,
          },
        }
      )
      .then((response) => {
        let responseHtml = response.data.url;
        window.open(responseHtml, '_blank');
      });
  };

  return (
    <TabPanel value={tabValue} index={index}>
      <StyledContent
        onScroll={onScroll}
        ref={scroll}
        showBorderTop={showBorderTop}
        showBorderBottom={showBorderBottom}
        isScrolledToBottom={isScrolledToBottom}
      >
        {connectionData?.data?.map((data, index) => {
          const { initial_context, reaction, next_context, timestamp } = data;
          return (
            <ConnectionInfo key={index}>
              <>
                <ConnectionDetails>
                  {timestamp && (
                    <p>
                      <span>Time:</span> {timestamp}
                    </p>
                  )}
                  {isExpert && (
                    <p>
                      <span>Inital context: </span>
                      {initial_context ? initial_context : 'Not available'}
                    </p>
                  )}
                  {isExpert && (
                    <p>
                      <span>Reaction: </span> {reaction ? reaction : 'Not available'}
                    </p>
                  )}
                  {isExpert && (
                    <p>
                      <span>New context: </span> {next_context ? next_context : 'Not available'}
                    </p>
                  )}
                </ConnectionDetails>
                <BorderContainer>
                  <LogWrapper>
                    <ConversationLog>
                      {data.log.map((data, index) => {
                        return Array.isArray(data.children) ? (
                          <Tree key={`${index}${data.value}`} data={data} />
                        ) : (
                          <p key={`${index}`}>
                            <span>{`${data.key}`}</span> {`${data.value}`}
                          </p>
                        );
                      })}
                    </ConversationLog>
                  </LogWrapper>
                </BorderContainer>
              </>
            </ConnectionInfo>
          );
        })}
      </StyledContent>
    </TabPanel>
  );
};

ModalFlow.propTypes = {
  data: PropTypes.array.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default ModalFlow;
